export const positiveOrZero = (
  num: number | null,
  message: string = 'This value must be greater or equal to 0',
): boolean | string => {
  if (!num && num !== 0) return message;
  return num >= 0 || message;
};
